import { useState } from "react";
import { FiX } from "react-icons/fi";
import { getInitials } from "../../utils/helpers";
import useAuthStore from "../../store/authStore";
import styles from "./ReactionDetailModal.module.css";

const ReactionDetailModal = ({ reactions, onClose }) => {
  const { user } = useAuthStore();

  // Build tab data: "All" + one tab per unique emoji
  const grouped = reactions.reduce((acc, r) => {
    if (!acc[r.emoji]) acc[r.emoji] = [];
    acc[r.emoji].push(r);
    return acc;
  }, {});

  const tabs = ["All", ...Object.keys(grouped)];
  const [activeTab, setActiveTab] = useState("All");

  const displayed =
    activeTab === "All" ? reactions : grouped[activeTab] || [];

  // Helper: get display name even if user is not populated (just an ID string)
  const getName = (r) => {
    if (!r.user) return "Unknown";
    if (typeof r.user === "string") {
      // Not populated - check if it's the current user
      return r.user === user._id ? user.name : "User";
    }
    return r.user.name || "User";
  };

  const getAvatar = (r) => {
    if (!r.user || typeof r.user === "string") return null;
    return r.user.avatar || null;
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className={styles.header}>
          <span className={styles.title}>Reactions</span>
          <button className={styles.closeBtn} onClick={onClose}>
            <FiX size={17} />
          </button>
        </div>

        {/* Tabs — All + per-emoji */}
        <div className={styles.tabs}>
          {tabs.map((tab) => (
            <button
              key={tab}
              className={`${styles.tab} ${activeTab === tab ? styles.tabActive : ""}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab === "All" ? (
                <span>All <span className={styles.tabCount}>{reactions.length}</span></span>
              ) : (
                <span>{tab} <span className={styles.tabCount}>{grouped[tab].length}</span></span>
              )}
            </button>
          ))}
        </div>

        {/* User list */}
        <div className={styles.list}>
          {displayed.map((r, i) => {
            const name = getName(r);
            const avatar = getAvatar(r);
            return (
              <div key={i} className={styles.row}>
                <div className={styles.avatarWrap}>
                  {avatar
                    ? <img src={avatar} alt={name} className={styles.avatarImg} />
                    : <span className={styles.avatarInitials}>{getInitials(name)}</span>}
                </div>
                <div className={styles.userInfo}>
                  <span className={styles.userName}>{name}</span>
                  {(typeof r.user !== "string" && r.user?.bio) && (
                    <span className={styles.userBio}>{r.user.bio}</span>
                  )}
                </div>
                <span className={styles.rowEmoji}>{r.emoji}</span>
              </div>
            );
          })}
          {displayed.length === 0 && (
            <p className={styles.empty}>No reactions yet</p>
          )}
        </div>

        {/* Drag handle */}
        <div className={styles.dragHandle} />
      </div>
    </div>
  );
};

export default ReactionDetailModal;
